import axios from 'axios';
import isEmail from 'validator/es/lib/isEmail';
import useFormData from './formData.hook';
import { useCallback } from 'react';

const PATH_CHECK_LOGIN = '/udata/emarket/checkuser.json';
const PATH_CHECK_PASSWORD = '/udata/users/checkdo.json';
const PATH_REGISTRATION = '/udata/users/registerUserCustome.json';
const PATH_RECOVERY = '/udata/users/forget_do_Custome.json';

export default function useCheck() {

    const phoneCheck = useCallback(async (phone, step = 'auth') => {

        if (phone.value.length !== 11)
            return { validation: null, message: '' };

        const response = await axios.post(PATH_CHECK_LOGIN, useFormData({
            phone: phone.value,
            step: step
        }));

        return {
            validation: response.data['chek_phone'],
            message: response.data['massage'].phone
        };

    }, []);

    const emailCheck = useCallback(async (email, phone = false, step = 'auth') => {

        const response = {
            validation: null,
            message: '',
        };

        const formData = phone !== false ? useFormData({
            email,
            phone: phone.value,
            step: step
        }) : useFormData({
            email,
            phone: phone.value,
            step: step
        });

        if (isEmail(email))
            await axios.post(PATH_CHECK_LOGIN, formData)
                .then(res => {
                    response.validation = res.data['chek_email'];
                    response.message = res.data['massage'].email;
                });

        return response;

    }, []);

    const doLogin = useCallback(async (login, password, step = 'auth', type = true) => {

        const data = {
            validation: null,
            message: ''
        };

        if (!login.validation || password.value.length < 6) return data;
        else {
            const body = useFormData({
                password: password.value,
                step: step
            });
            body.append(type ? 'phone' : 'email', login.value);

            const response = await axios.post(PATH_CHECK_PASSWORD, body);

            if (response.data['phone']) {
                window.location = response.data['redirect-url'];
                data.validation = true;
            } else {
                data.validation = false;
                data.message = 'Ввёдёт неверный пароль! Попробуйте ввести другой или восстановить';
            }
            return data;
        }

    }, []);

    const doRegistration = useCallback(async (phone, email) => {

        if (phone.validation && email.validation)
            await axios.post(PATH_REGISTRATION, useFormData({
                phone: phone.value,
                email: email.value,
            })).then(res => res.data['reg'] ? window.location = res.data['redirect-url'] : null);

    }, []);

    const doRecovery = useCallback(async (login, activePhone) => {
        if (login.validation) {
            await axios.post(PATH_RECOVERY, useFormData(
                activePhone ? { phone: login.value } : { email: login.value }
            ));
        }

    }, []);

    return { phoneCheck, emailCheck, doLogin, doRegistration, doRecovery };
}